import { doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebase";

export async function isWhiteLabelEnabled(instructorId: string): Promise<boolean> {
  try {
    const userDoc = await getDoc(doc(db, "users", instructorId));
    if (userDoc.exists()) {
      const userData = userDoc.data();
      const tier = userData.subscriptionTier || "free";
      
      // White-label is only available for Pro+ Yearly
      return tier === "pro_plus_yearly";
    }
    return false;
  } catch (error) {
    console.error("Error checking white-label status:", error);
    return false;
  }
}

export function shouldShowEduMiBranding(isWhiteLabel: boolean): boolean {
  return !isWhiteLabel;
}
